document.addEventListener("DOMContentLoaded", function() {
  var accordionTitles = document.querySelectorAll('.accordion-title');

  accordionTitles.forEach(function(title) {
    title.addEventListener('click', function() {
      var paragraph = this.nextElementSibling; // Get the next sibling element (accordion-paragraph)

      // Toggle the 'active' class on the accordion-title
      this.classList.toggle('active');

      // Toggle the 'active' class on the accordion-paragraph
      paragraph.classList.toggle('active');
    });
  });
});






document.addEventListener('DOMContentLoaded', function () {
  // Only run on the stylish product template
  if (!document.body.classList.contains('template-name--stylish-product')) return;

  const quantityForm = document.querySelector('#Quantity-Form-template--23201215217687__main');
  const visibleSubmitButton = document.querySelector('#ProductSubmitButton-template--23201215217687__main');
  const productForm = document.querySelector('form[action="/cart/add"]');
  const subscriptionWidget = document.querySelector('#appstle_subscription_widget0');

  if (quantityForm && visibleSubmitButton && productForm) {
    // Clone submit button
    const clonedButton = visibleSubmitButton.cloneNode(true);
    clonedButton.id = 'ClonedSubmitButton';

    // Create quantity + button wrapper
    const flexWrapper = document.createElement('div');
    flexWrapper.className = 'quantity-and-button';
    flexWrapper.appendChild(quantityForm);
    flexWrapper.appendChild(clonedButton);

    // Insert subscription widget first (if it exists)
    const targetContainer = document.querySelector('.product-form__buttons');
    if (subscriptionWidget && targetContainer) {
      targetContainer.appendChild(subscriptionWidget);
    }

    // Then insert the quantity + button wrapper
    targetContainer.appendChild(flexWrapper);

    // Hide original button in form
    visibleSubmitButton.style.display = 'none';

    // Link cloned button to submit
    clonedButton.addEventListener('click', function (e) {
      e.preventDefault();
      visibleSubmitButton.disabled = false;
      visibleSubmitButton.click();
    });
  }
});







  document.addEventListener('DOMContentLoaded', function () {
    const scrollContainer = document.querySelector('.vitamin-cards');

    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', function () {
        const scrollLeft = scrollContainer.scrollLeft;
        const scrollWidth = scrollContainer.scrollWidth;
        const clientWidth = scrollContainer.clientWidth;
        const scrollRight = scrollWidth - scrollLeft - clientWidth;

        // Add .scrolled class when user scrolls right
        if (scrollLeft > 10) {
          scrollContainer.classList.add('scrolled');
        } else {
          scrollContainer.classList.remove('scrolled');
        }

        // Add .at-end class when near the end
        if (scrollRight < 20) {
          scrollContainer.classList.add('at-end');
        } else {
          scrollContainer.classList.remove('at-end');
        }
      });
    }
  });


if (window.matchMedia('(min-width: 769px)').matches){
  
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('.vitamin-comparison-section');
  const cards = document.querySelectorAll('.vitamin-cards .vitamin-card');

  const scatterTransforms = [
    'translate(3rem, -2rem) rotate(6deg)',
    'translate(-14rem, -28rem) rotate(-4deg)',
    'translate(-55rem, -5rem) rotate(-14deg)'
  ];

  function applyScatter() {
    cards.forEach((card, index) => {
      if (index < scatterTransforms.length) {
        card.style.transform = scatterTransforms[index];
      } else {
        card.style.transform = 'none';
      }
    });
  }

  function resetScatter() {
    cards.forEach(card => {
      card.style.transform = 'none';
    });
  }

  function handleScroll() {
    const top = section.getBoundingClientRect().top;
    if (top <= 75) {
      resetScatter();
    } else {
      applyScatter();
    }
  }

  // Apply initial scatter
  cards.forEach(card => {
    card.style.transition = 'transform 0.6s ease';
  });
  applyScatter();

  // Listen for scroll to trigger transition back
  window.addEventListener('scroll', handleScroll);
});


}


document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".vitamin-card-simple-grid .ss-col-12");
  const items = container?.querySelectorAll(".ss-grid__item");

  if (container && items.length >= 2) {
    const secondItem = items[1];
    const offset = secondItem.offsetLeft - (window.innerWidth / 2) + (secondItem.offsetWidth / 2);
    container.scrollLeft = offset;
  }
});








document.addEventListener("DOMContentLoaded", function () {
  const menus = document.querySelectorAll('header-menu > details');

  menus.forEach((menu) => {
    const summary = menu.querySelector('summary');

    if (!summary) return;

    summary.addEventListener('mouseenter', () => {
      console.log('Hovered over menu:', menu);
      menu.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    menu.addEventListener('mouseleave', () => {
      console.log('Mouse left menu:', menu);
      menu.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });
  });
});





document.addEventListener('shopify:section:load', autoplayVisibleVideo); // If using dynamic section loading
document.addEventListener('DOMContentLoaded', autoplayVisibleVideo);
document.addEventListener('click', () => setTimeout(autoplayVisibleVideo, 100)); // In case the video shows after a click

function autoplayVisibleVideo() {
  const mediaItems = document.querySelectorAll('.product__media-item.is-active');

  mediaItems.forEach(item => {
    const deferredMedia = item.querySelector('deferred-media__desktop');
    if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
      deferredMedia.loadContent(); // Force video into the DOM
    }

    const video = item.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {}); // Avoid autoplay error
    }
  });
}






/*

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.template-name--merch');

  if (!container) return;

  const quantityForm = container.querySelector('.product-form__quantity');
  const productButtons = container.querySelector('.product-form__buttons');

  if (quantityForm && productButtons) {
    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'quantity-button-wrapper';
    wrapper.style.display = 'flex';
    wrapper.style.gap = '1rem';
    wrapper.style.alignItems = 'center';
    wrapper.style.flexWrap = 'wrap';

    // Insert wrapper before quantity form
    quantityForm.parentNode.insertBefore(wrapper, quantityForm);

    // Move both elements inside the wrapper
    wrapper.appendChild(quantityForm);
    wrapper.appendChild(productButtons);
  }
});
*/








// new mobile menu //

document.querySelectorAll('.accordion-trigger').forEach((trigger) => {
  const parent = trigger.parentElement;
  const submenu = parent.querySelector('.grand_sub_menu_wrapper ul');

  // Start in open state
  parent.classList.add('open');

  // Ensure the span is there for CSS to target
  if (!trigger.querySelector('.accordion-symbol')) {
    const symbolSpan = document.createElement('span');
    symbolSpan.classList.add('accordion-symbol');
    trigger.appendChild(symbolSpan);
  }

  // Only intercept clicks if there's actually a submenu
  trigger.addEventListener('click', (e) => {
    if (submenu && submenu.children.length > 0) {
      e.preventDefault(); // prevent following the link
      parent.classList.toggle('open');
    }
    // else let it navigate normally
  });
});


document.querySelectorAll('.menu-drawer__menu > li').forEach((li) => {
  if (!li.classList.contains('accordion-item')) {
    li.classList.add('menu-drawer__top-item');
  }
});








/*EXTERNAL LINKS IN NEW TAB*/


  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('a[href^="http"]:not([target])');

    links.forEach(link => {
      const isExternal = link.hostname !== window.location.hostname;
      if (isExternal) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  });




document.addEventListener('DOMContentLoaded', function () {
  // Mobile only
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  // Use the *outer* gallery container that visually covers the main image
  // Update these selectors if needed based on your markup
  const swipeArea =
    document.querySelector('.product__media-wrapper') ||   // nice big wrapper if present
    document.querySelector('[id^="Slider-Gallery"]') ||    // Dawn-style
    document.querySelector('.product__media-list');        // fallback

  // Try to find arrows near the gallery (so this works on any product template)
  const context = swipeArea ? swipeArea.closest('section, .product, body') : document;

  const nextBtn =
    context.querySelector('.slider-button--next') ||
    context.querySelector('.product-media-nav__button--next');

  const prevBtn =
    context.querySelector('.slider-button--prev') ||
    context.querySelector('.product-media-nav__button--prev');

  if (!swipeArea || !nextBtn || !prevBtn) {
    console.log('[BOW swipe] Missing element:', {
      swipeArea: !!swipeArea,
      nextBtn: !!nextBtn,
      prevBtn: !!prevBtn
    });
    return;
  }

  let startX = null;
  let tracking = false;
  const SWIPE_THRESHOLD = 40; // px

  // Start tracking when the touch begins anywhere inside the main media area
  swipeArea.addEventListener(
    'touchstart',
    function (e) {
      if (!e.touches || !e.touches.length) return;
      startX = e.touches[0].clientX;
      tracking = true;
    },
    { passive: true }
  );

  // Finish tracking even if the touch ends slightly outside the area
  document.addEventListener(
    'touchend',
    function (e) {
      if (!tracking || startX === null || !e.changedTouches || !e.changedTouches.length) return;

      const endX = e.changedTouches[0].clientX;
      const deltaX = endX - startX;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD) {
        startX = null;
        tracking = false;
        return;
      }

      if (deltaX < 0) {
        // Swipe left → next
        nextBtn.click();
      } else {
        // Swipe right → prev
        prevBtn.click();
      }

      startX = null;
      tracking = false;
    },
    { passive: true }
  );
});
















/* KACHING */


document.addEventListener(
  'pointerdown',
  (event) => {
    const purchaseOption = event.target.closest(
      '.kaching-bundles__subscriptions > .kaching-bundles__bar'
    );

    if (!purchaseOption) return;

    const block = purchaseOption.closest('kaching-bundles-block');
    if (!block) return;

    const purchaseOptions = [
      ...purchaseOption.parentElement.children
    ].filter((element) =>
      element.classList.contains('kaching-bundles__bar')
    );

    const oneTimeOption = purchaseOptions.at(-1);

    block.classList.toggle(
      'kaching-one-time-active',
      purchaseOption === oneTimeOption
    );
  },
  true
);




document.addEventListener(
  'submit',
  (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');

    if (!form) return;

    const sellingPlanInput = form.querySelector(
      '[name="selling_plan"]'
    );

    const sellingPlan = sellingPlanInput?.value;

    if (!sellingPlan) return;

    // Remove any previous unique subscription ID
    form
      .querySelector('[name="properties[_subscription_instance]"]')
      ?.remove();

    // Give this subscription add its own unique cart line
    const uniqueProperty = document.createElement('input');

    uniqueProperty.type = 'hidden';
    uniqueProperty.name = 'properties[_subscription_instance]';
    uniqueProperty.value =
      crypto.randomUUID?.() ||
      `${Date.now()}-${Math.random()}`;

    form.appendChild(uniqueProperty);
  },
  true
);









function hideSubscriptionQuantitySelectors() {
  document.querySelectorAll('.cart-item').forEach((item) => {
    const isDeliveryItem = [...item.querySelectorAll('.product-option')]
      .some((option) =>
        option.textContent.toUpperCase().includes('SUPPLY')
      );

    if (!isDeliveryItem) return;

    const quantitySelector = item.querySelector('quantity-input');

    if (quantitySelector) {
      quantitySelector.style.display = 'none';
    }

    const quantityPrice = item.querySelector(
      '.cart-item__name + .product-option'
    );

    if (quantityPrice) {
      quantityPrice.style.display = 'none';
    }
  });
}

const subscriptionQuantityObserver = new MutationObserver(() => {
  hideSubscriptionQuantitySelectors();
});

subscriptionQuantityObserver.observe(document.body, {
  childList: true,
  subtree: true
});

hideSubscriptionQuantitySelectors();









function moveKachingLabelsUnderPrice() {
  document
    .querySelectorAll('.kaching-bundles__bar-content')
    .forEach((content) => {
      const label = content.querySelector(
        '.kaching-bundles__bar-label'
      );

      const pricing = content.querySelector(
        '.kaching-bundles__bar-pricing'
      );

      if (!label || !pricing) return;

      if (label.parentElement !== pricing) {
        pricing.appendChild(label);
      }
    });
}

const kachingLabelObserver = new MutationObserver(() => {
  moveKachingLabelsUnderPrice();
});

kachingLabelObserver.observe(document.body, {
  childList: true,
  subtree: true
});

moveKachingLabelsUnderPrice();









let updatingKachingPurchaseType = false;

function getKachingElements(block) {
  if (!block) return null;

  const subscriptions = block.querySelector(
    '.kaching-bundles__subscriptions'
  );

  if (!subscriptions) return null;

  const purchaseOptions = [
    ...subscriptions.querySelectorAll(
      ':scope > .kaching-bundles__bar'
    )
  ];

  const subscribeOption = purchaseOptions.find((option) => {
    const title = option.querySelector(
      '.kaching-bundles__subscriptions__title'
    );

    return title?.textContent
      .trim()
      .toUpperCase()
      .includes('SUBSCRIBE');
  });

  const oneTimeOption = purchaseOptions.find((option) => {
    const title = option.querySelector(
      '.kaching-bundles__subscriptions__title'
    );

    return title?.textContent
      .trim()
      .toUpperCase()
      .includes('ONE-TIME');
  });

  const deliveryOptions = block.querySelector(
    '.kaching-bundles__block > .kaching-bundles__bars:not(.kaching-bundles__subscriptions)'
  );

  if (
    !subscribeOption ||
    !oneTimeOption ||
    !deliveryOptions
  ) {
    return null;
  }

  return {
    subscribeOption,
    oneTimeOption,
    deliveryOptions
  };
}

document.addEventListener(
  'click',
  (event) => {
    if (updatingKachingPurchaseType) return;

    /* -------------------------
       ONE-TIME PURCHASE
    -------------------------- */

    const purchaseOption = event.target.closest(
      '.kaching-bundles__subscriptions > .kaching-bundles__bar'
    );

    if (purchaseOption) {
      const title =
        purchaseOption
          .querySelector(
            '.kaching-bundles__subscriptions__title'
          )
          ?.textContent.trim()
          .toUpperCase() || '';

      if (!title.includes('ONE-TIME')) {
        requestAnimationFrame(updateKachingVisualState);
        return;
      }

      const block = purchaseOption.closest(
        'kaching-bundles-block'
      );

      const elements = getKachingElements(block);

      if (!elements) return;

      const oneBottleOption =
        elements.deliveryOptions.querySelector(
          '[data-deal-bar-id="xMR0"]'
        );

      if (!oneBottleOption) return;

      const oneBottleSelected =
        oneBottleOption.classList.contains(
          'kaching-bundles__bar--selected'
        );

      /*
       * One bottle is already selected internally,
       * so allow One-Time Purchase to proceed normally.
       */
      if (oneBottleSelected) {
        requestAnimationFrame(updateKachingVisualState);
        return;
      }

      /*
       * Select one bottle first, then switch to One-Time.
       */
      event.preventDefault();
      event.stopImmediatePropagation();

      updatingKachingPurchaseType = true;

      const oneBottleButton =
        oneBottleOption.querySelector(
          '.kaching-bundles__bar-main'
        ) ||
        oneBottleOption.querySelector('label') ||
        oneBottleOption;

      oneBottleButton.click();

      requestAnimationFrame(() => {
        purchaseOption.click();

        requestAnimationFrame(() => {
          updatingKachingPurchaseType = false;
          updateKachingVisualState();
        });
      });

      return;
    }

    /* -------------------------
       DELIVERY OPTIONS
    -------------------------- */

    const deliveryBar = event.target.closest(
      '.kaching-bundles__bars > .kaching-bundles__bar[data-deal-bar-id]'
    );

    if (!deliveryBar) return;

    const block = deliveryBar.closest(
      'kaching-bundles-block'
    );

    const elements = getKachingElements(block);

    if (!elements) return;

    const isOneTime =
      elements.oneTimeOption.classList.contains(
        'kaching-bundles__bar--selected'
      );

    /*
     * Subscribe is already active, so allow Kaching
     * to handle the delivery-option click normally.
     */
    if (!isOneTime) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    updatingKachingPurchaseType = true;

    const deliveryIsAlreadySelected =
      deliveryBar.classList.contains(
        'kaching-bundles__bar--selected'
      );

    /*
     * Remove the One-Time visual state immediately.
     */
    block.classList.remove('kaching-one-time-active');

    /*
     * Silently switch Kaching back to Subscribe.
     */
    elements.subscribeOption.click();

    requestAnimationFrame(() => {
      /*
       * One-Time already retains 30 Day internally.
       * Only click the delivery bar when a different
       * option, such as 60 Day, was selected.
       */
      if (!deliveryIsAlreadySelected) {
        const deliveryButton =
          deliveryBar.querySelector(
            '.kaching-bundles__bar-main'
          ) ||
          deliveryBar.querySelector('label') ||
          deliveryBar;

        deliveryButton.click();
      }

      requestAnimationFrame(() => {
        updatingKachingPurchaseType = false;
        updateKachingVisualState();
      });
    });
  },
  true
);

function updateKachingVisualState() {
  document
    .querySelectorAll('kaching-bundles-block')
    .forEach((block) => {
      const elements = getKachingElements(block);

      if (!elements) return;

      const isOneTime =
        elements.oneTimeOption.classList.contains(
          'kaching-bundles__bar--selected'
        );

      /*
       * Always keep the delivery options visible.
       */
      elements.deliveryOptions.style.display = '';

      block.classList.toggle(
        'kaching-one-time-active',
        isOneTime
      );
    });
}

const kachingObserver = new MutationObserver(() => {
  if (updatingKachingPurchaseType) return;

  requestAnimationFrame(updateKachingVisualState);
});

kachingObserver.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
});

updateKachingVisualState();








const kachingPriceState = new WeakMap();

let updatingKachingPrices = false;
let kachingPriceFrame;

function getKachingOneTimeOption(block) {
  const options = [
    ...block.querySelectorAll(
      '.kaching-bundles__subscriptions > .kaching-bundles__bar'
    )
  ];

  /*
   * The subscription option normally has both a discounted
   * price and a crossed-out full price. The one-time option
   * normally has only a single price.
   */
  return (
    options.find(
      (option) =>
        option.querySelector('.kaching-bundles__bar-price') &&
        !option.querySelector(
          '.kaching-bundles__bar-full-price'
        )
    ) ||
    options.at(-1) ||
    null
  );
}

function getBarPricing(bar) {
  return {
    price: bar.querySelector(
      '.kaching-bundles__bar-price'
    ),
    fullPrice: bar.querySelector(
      '.kaching-bundles__bar-full-price'
    ),
    label: bar.querySelector(
      '.kaching-bundles__bar-label'
    )
  };
}

function getText(element) {
  return element?.textContent.trim() || null;
}

function setText(element, value) {
  if (
    element &&
    value !== null &&
    value !== undefined &&
    element.textContent.trim() !== value
  ) {
    element.textContent = value;
  }
}

function preserveKachingPricing() {
  if (updatingKachingPrices) return;

  document
    .querySelectorAll('kaching-bundles-block')
    .forEach((block) => {
      /*
       * These IDs are more reliable than customer-facing
       * titles, subtitles, labels or promotional language.
       */
      const thirtyDayBar = block.querySelector(
        '[data-deal-bar-id="xMR0"]'
      );

      const sixtyDayBar = block.querySelector(
        '[data-deal-bar-id="cDyZ"]'
      );

      const oneTimeOption =
        getKachingOneTimeOption(block);

      if (
        !thirtyDayBar ||
        !sixtyDayBar ||
        !oneTimeOption
      ) {
        return;
      }

      const thirtyDay =
        getBarPricing(thirtyDayBar);

      const sixtyDay =
        getBarPricing(sixtyDayBar);

      const oneTimePrice =
        oneTimeOption.querySelector(
          '.kaching-bundles__bar-price'
        );

      let saved = kachingPriceState.get(block);

      /*
       * Save Kaching's original discounted subscription
       * values once, before switching options can alter them.
       *
       * Labels are optional because Kaching may remove them
       * or the client may change the promotional language.
       */
      if (!saved) {
        const thirtyDayPrice =
          getText(thirtyDay.price);

        const thirtyDayFullPrice =
          getText(thirtyDay.fullPrice);

        const sixtyDayPrice =
          getText(sixtyDay.price);

        const sixtyDayFullPrice =
          getText(sixtyDay.fullPrice);

        const hasSubscriptionPrices =
          thirtyDayPrice &&
          thirtyDayFullPrice &&
          sixtyDayPrice &&
          sixtyDayFullPrice;

        if (!hasSubscriptionPrices) return;

        saved = {
          thirtyDay: {
            price: thirtyDayPrice,
            fullPrice: thirtyDayFullPrice,
            label: getText(thirtyDay.label)
          },

          sixtyDay: {
            price: sixtyDayPrice,
            fullPrice: sixtyDayFullPrice,
            label: getText(sixtyDay.label)
          },

          /*
           * The 30-day bar's original full price is the
           * standard one-bottle, one-time purchase price.
           */
          oneTime: thirtyDayFullPrice
        };

        kachingPriceState.set(block, saved);
      }

      updatingKachingPrices = true;

      try {
        setText(
          thirtyDay.price,
          saved.thirtyDay.price
        );

        setText(
          thirtyDay.fullPrice,
          saved.thirtyDay.fullPrice
        );

        setText(
          thirtyDay.label,
          saved.thirtyDay.label
        );

        setText(
          sixtyDay.price,
          saved.sixtyDay.price
        );

        setText(
          sixtyDay.fullPrice,
          saved.sixtyDay.fullPrice
        );

        setText(
          sixtyDay.label,
          saved.sixtyDay.label
        );

        setText(
          oneTimePrice,
          saved.oneTime
        );
      } finally {
        updatingKachingPrices = false;
      }
    });
}

const kachingPriceObserver =
  new MutationObserver(() => {
    if (updatingKachingPrices) return;

    cancelAnimationFrame(kachingPriceFrame);

    kachingPriceFrame = requestAnimationFrame(
      preserveKachingPricing
    );
  });

kachingPriceObserver.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});

preserveKachingPricing();